import { CONSORS_INDUSTRIES } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsIndustry = z.nativeEnum(CONSORS_INDUSTRIES);
export type SchemaConsorsIndustry = z.infer<typeof schemaConsorsIndustry>;
